import { toDateInput } from '../../utils/format';

export const WORK_LABEL = { CUTTING: 'Cutting', STITCHING: 'Stitching' };

export const ZONE_LABEL = { UPPER: 'Upper Body', LOWER: 'Lower Body', FULL: 'Full / General' };
export const ZONE_ORDER = ['UPPER', 'LOWER', 'FULL'];

/**
 * True once an ISO date is before today in the viewer's calendar. A job due
 * today is not late yet, so this compares calendar days, not timestamps.
 */
export function isPastDay(iso) {
  if (!iso) return false;
  return toDateInput(iso) < toDateInput(new Date());
}
